var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{staticClass:"letter-avatar shadow",class:{over: _vm.over},attrs:{"size":_vm.size}},[_c('span',{staticClass:"white--text headline",style:(_vm.fontStyle)},[_vm._v(_vm._s(_vm.inicial))])])}
var staticRenderFns = []

export { render, staticRenderFns }